export default __webpack_public_path__ + "assets/images/c6cfbe8c8f6a12f2cf009f726ec5d923.png";